import { useRecoilState } from 'recoil';
import { userStore } from 'stores/userStore';

export const useColors = () => {
	const [colors, setColors] = useRecoilState(userStore.colorsSettings);
	return { colors: colors.colors, setColors };
};
